import React from 'react';

import { getArrayOfIdsOfParentFunctions } from 'screens/admin/FunctionAndGrade/Helpers';
import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography2, Typography5 } from 'uiToolkit/Typography';

import { FunctionAndRoleListElement, StyledListItemWrapper } from './ClickToSetVerticalNavbar';

const FunctionRoleSelectorList = ({
  selectedFunction = {},
  setSelectedNav = () => {},
  selectedUuids = [],
  index = 0,
  handleOnChange = () => {},
  functions = [],
  jobFunctionRole,
  selectAllLevels = () => {},
  removeAllLevels = () => {},
  //   functionsAndRoles = [],
  //   selectRole,
  //   selectFunction
}) => {
  const showAllRoles = !(selectedFunction?.childFunctions?.length > 0);

  const getAllLevelsSelected = (functionUuid) => {
    if (jobFunctionRole && Array.isArray(jobFunctionRole)) {
      const selectedFunctionsJobLevels = jobFunctionRole.find((j) => j.uuid === functionUuid)?.jobRoleList;
      if (selectedFunctionsJobLevels?.length === selectedFunction?.roles?.length) {
        return true;
      }
      return false;
    }
    return false;
  };

  const getJobLevelSelected = (functionUuid, jobLevelUuid) => {
    if (jobFunctionRole) {
      const jobFunc = jobFunctionRole.find((j) => j.uuid === functionUuid);
      if (jobFunc) {
        return jobFunc?.jobRoleList?.find((j) => j.uuid === jobLevelUuid) ?? false;
      }
      return false;
    }
    return false;
  };

  const getJobLevelSelectedCount = (functionUuid, jobLevelUuid) => {
    if (jobFunctionRole) {
      const jobFunc = jobFunctionRole.find((j) => {
        if (j.parentId) {
          const arrayOfParentIds = getArrayOfIdsOfParentFunctions(functions, j)?.map(({ uuid }) => uuid);
          if (arrayOfParentIds.includes(functionUuid)) {
            return j;
          }
          if (j.uuid === functionUuid) {
            return j;
          }
        } else {
          return j.uuid === functionUuid;
        }
      });
      if (jobFunc) {
        return jobFunc?.jobRoleList?.length;
      }
      return 0;
    }
    return 0;
  };

  return (
    <Container>
      {showAllRoles && (
        <OptionWrapper
          onClick={() => {
            if (getAllLevelsSelected(selectedFunction.function.uuid)) {
              removeAllLevels(selectedFunction.function.uuid);
            } else {
              selectAllLevels(selectedFunction.function.uuid);
            }
          }}
        >
          <FunctionAndRoleListElement
            label="All Roles"
            radioColor={theme.palette.primary.main}
            checked={getAllLevelsSelected(selectedFunction.function.uuid)}
          />
        </OptionWrapper>
      )}
      {selectedFunction?.childFunctions?.map((childFunc) => {
        const { name, uuid } = childFunc.function;
        return (
          <StyledListItemWrapper
            key={uuid}
            isSelected={selectedUuids.includes(uuid)}
            handleOnClick={() => {
              setSelectedNav((prev) => {
                if (!selectedUuids.includes('everyone')) {
                  if (selectedUuids.includes(uuid)) {
                    return prev;
                  }
                  let modifiedNav = [...prev];
                  modifiedNav[index + 1] = { uuid, name };
                  modifiedNav = modifiedNav.slice(0, index + 2);

                  return modifiedNav;
                }
                return [{ uuid, name }];
              });
            }}
          >
            <Typography2
              //   color={uuid === selectedNav ? theme.palette.text.primaryBlue : 'textSecondary'}
              cursor="pointer"
              style={{
                padding: '0.25rem',
                maxWidth: '7rem',
              }}
            >
              {name}
            </Typography2>
            {getJobLevelSelectedCount(uuid) > 0 ? (
              <SelectedOptionsContainer>
                <Typography5 style={{ lineHeight: 1 }} customColor={theme.palette.text.white}>
                  {getJobLevelSelectedCount(uuid)}
                </Typography5>
              </SelectedOptionsContainer>
            ) : null}
          </StyledListItemWrapper>
        );
      })}
      {selectedFunction?.roles?.map((role) => {
        const { name, uuid } = role ?? {};
        const selected = getJobLevelSelected(selectedFunction.function.uuid, uuid);
        return (
          <OptionWrapper onClick={() => handleOnChange(selectedFunction.function.uuid, uuid)}>
            <FunctionAndRoleListElement
              key={`${uuid}-role`}
              label={name}
              radioColor={theme.palette.primary.main}
              checked={selected}
            />
          </OptionWrapper>
        );
      })}
    </Container>
  );
};

const OptionWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

const Container = styled.div`
  min-width: 15rem;
  flex: 1;
`;

const SelectedOptionsContainer = styled.div`
  height: 26px;
  width: 26px;
  background-color: ${theme.palette.background.blue.dark.v1};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

export default FunctionRoleSelectorList;
